module.exports = __webpack_public_path__ + "img/tree-07-i-leaves.864b86da.png";